import { fmtBRL } from '@/lib/utils';

interface LancKPICardsProps {
  aPagar: number;
  pendCount: number;
  concilCount: number;
  totalCount: number;
}

/**
 * 2 KPI cards do topo da tela Lançamentos.
 * "A pagar" (valor pendente) + "Conciliado" (X/Y + %).
 */
export function LancKPICards({ aPagar, pendCount, concilCount, totalCount }: LancKPICardsProps) {
  const pct = totalCount > 0 ? Math.round((concilCount / totalCount) * 100) : 0;

  const cardStyle = {
    background: 'var(--card)',
    border: '1px solid var(--card-stroke)',
    borderRadius: 'var(--r-3)',
    padding: 12,
  };

  const eyebrowStyle = {
    fontSize: 10,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.07em',
    color: 'var(--fg-muted)',
    fontFamily: 'var(--font-mono)',
    fontWeight: 600,
  };

  const valueStyle = {
    fontFamily: 'var(--font-mono)',
    fontSize: 20,
    fontWeight: 700,
    marginTop: 4,
    fontVariantNumeric: 'tabular-nums' as const,
    color: 'var(--fg)',
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
      <div style={cardStyle}>
        <div style={eyebrowStyle}>A pagar</div>
        <div style={valueStyle}>{fmtBRL(aPagar).replace(',00', '')}</div>
        <div style={{ fontSize: 10.5, color: 'var(--fg-muted)', marginTop: 2 }}>
          {pendCount} pendente{pendCount !== 1 ? 's' : ''}
        </div>
      </div>
      <div style={cardStyle}>
        <div style={eyebrowStyle}>Conciliado</div>
        <div style={valueStyle}>
          {concilCount} / {totalCount}
        </div>
        <div style={{ fontSize: 10.5, color: 'var(--pass)', marginTop: 2 }}>{pct}%</div>
      </div>
    </div>
  );
}
